import React from "react";
import ScrollToTop from "react-scroll-to-top";
import { NavLink } from "react-router-dom";
import useWebsiteSetting, {useServicedata} from "../FetchAPI";

export default function Footer() {

    const [webSetting] = useWebsiteSetting();
    const [servicedata] = useServicedata();
  return (
    <>
  
<footer className="footer_new">

    <div className="container">

        <div className="row">

            {/* About Company */}
            <div className="col-lg-4 col-md-6">

                <div className="footer_widget">

                    <NavLink className="footer_logo" to="/">
                        <img
  src={webSetting?.footerlogo}
  alt={webSetting?.website_name}
  title={webSetting?.website_name}
  style={{
    width: "200px",
    height: "50px",
    objectFit: "contain"
  }}
/>
                    </NavLink>

                    <p className="footer_desc">
                        We provide professional Name Change, Gazette,
                        Aadhaar, PAN Card, Passport and Document
                        Correction services with complete support and
                        documentation assistance.
                    </p>

                </div>

            </div>

            {/* Services */}
            <div className="col-lg-3 col-md-6">

                <div className="footer_widget">

                    <h4>Our Services</h4>

                    <ul className="footer_links">

                        {servicedata.slice(0,5).map((value,index)=>(
                            <li key={index}>
                                <NavLink to="/services">
                                    {value.name}
                                </NavLink>
                            </li>
                        ))}

                    </ul>

                </div>

            </div>

            {/* Pages */}
            <div className="col-lg-2 col-md-6">

                <div className="footer_widget">

                    <h4>Quick Links</h4>

                    <ul className="footer_links">

                        <li><NavLink to="/">Home</NavLink></li>
                        <li><NavLink to="/about">About Us</NavLink></li>
                        <li><NavLink to="/services">Services</NavLink></li>
                        <li><NavLink to="/blog/en">Blogs</NavLink></li>
                        <li><NavLink to="/contact">Contact</NavLink></li>

                    </ul>

                </div>

            </div>

            {/* Contact */}
            <div className="col-lg-3 col-md-6">

                <div className="footer_widget">

                    <h4>Contact Us</h4>

                    <ul className="footer_contact">

                        <li>
                            <i className="fa fa-phone"></i>
                            {webSetting.number}
                        </li>

                        <li>
                            <i className="fa fa-envelope"></i>
                            {webSetting.email}
                        </li>

                        <li>
                            <i className="fa fa-map-marker"></i>
                            {webSetting.address}
                        </li>

                    </ul>

                    <div className="footer_social">

                        <NavLink to={webSetting.facebook}>
                            <i className="fa fa-facebook"></i>
                        </NavLink>

                        <NavLink to={webSetting.instagram}>
                            <i className="fa fa-instagram"></i>
                        </NavLink>

                        <NavLink to={webSetting.twitter}>
                            <i className="fa fa-twitter"></i>
                        </NavLink>

                        <NavLink to={webSetting.linkedIn}>
                            <i className="fa fa-linkedin"></i>
                        </NavLink>

                    </div>

                </div>

            </div>

        </div>

        <div className="footer_bottom_new">

            <div className="row align-items-center">

                <div className="col-md-6">
                    <p>{webSetting.copyright}</p>
                </div>

                <div className="col-md-6 text-md-end">

                    <NavLink to="/privacypolicy">
                        Privacy Policy
                    </NavLink>

                    <span>|</span>

                    <NavLink to="/termsconditions">
                        Terms & Conditions
                    </NavLink>

                    <span>|</span>

                    <NavLink to="/refundpolicy">
                        Refund Policy
                    </NavLink>



                </div>

            </div>

        </div>

    </div>

</footer>

      <a
        href={`https://wa.me/${webSetting.whatsaap}?text=Hi, I would like to speak to a Name Change Service`}
        className="wa-float-img-circle"
        target="_blank"
        rel="noreferrer"
      >
        <i className="fa fa-whatsapp" aria-hidden="true"></i>
      </a>

      <a
        href={`tel:${webSetting.number}`}
        className="call-float-img-circle"
        target="_blank"
        rel="noreferrer"
      >
        <i className="fa fa-phone" aria-hidden="true"></i>
      </a>

      <ScrollToTop smooth="true" />
    </>
  );
}
